(function() {
	'use strict';



	angular.module('ShargoApp')

		.filter('addZeros', function() {
			return function addZeros(input) {
				return ("00" + input).slice(-2);
			}
		})

		.filter('formatDuration', function() {
			return function(input) {
				return (input == 0) ? "" : Math.ceil(input) + " min";
			}
		})

		.controller('TrackPackageController', function($rootScope, $scope, $routeParams, $q, $interval, $timeout, $filter, $translate, $location, $window, Analytics, _, Configuration, DeliversService, toolsService) {
			$rootScope.pageConfiguration = {
				footer: false,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: '',
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : ($rootScope.device.os === "ios" ? $filter('translate')('header.download-app-ios') : $filter('translate')('header.download-app-android')),
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : ($rootScope.device.os === "ios" ? 'header.download-ios' : 'header.download-android'),
						target: $rootScope.device.isDesktop ? '' : '_blank',
						hide: false,
						disabled: false
					},
					profile: false
				}
			};

			Analytics.trackEvent('TrackingLink', 'open', 'Tracking link opens');

			var driverStatuses = ['assigned', 'in_route'];
			$scope.deliveredStatuses = ['delivered', 'delivered_with_errors', 'canceled', 'returned'];
			$scope.rateConfirmationEnabled = false;
			var ask4Shargo = "Preparing your order";
			var estimatedPickup = "Estimated pickup";

			$rootScope.$on('$translateChangeSuccess', function () {
				var trackTrans = ['track-package.ask4Shargo', 'track-package.estimatedPickup'];
				$translate(trackTrans).then(function(trans) {
					ask4Shargo = trans[trackTrans[0]];
					estimatedPickup = trans[trackTrans[1]];
				});
			});

			//$rootScope.landingHeader = true;
			$scope.ratingBundle = {
				score: 0,
				readOnly: false,
				reseteable: false
			};
			$scope.enableRateConfirmation = function() {
				if($scope.ratingBundle && $scope.ratingBundle.score > 0) {
					$scope.rateConfirmationEnabled = true;
				}
			};

			// Status:  'created', 'no_found', 'pending_driver_acceptance', 'driver'

			$scope.ratingFeedback = "";
			$scope.markers = [];
			$scope.errorList = [];
			var oldValues = {};

			$scope.cleanView = function() {
				$scope.origin = undefined;
				$scope.destination = undefined;
				$scope.transport = "";
				$scope.orderDate = "";
				$scope.status = "Loading...";
				$scope.closingReason = "";
				$scope.driver = undefined;
				$scope.statusClass = "";
				$scope.yourShargoInfo = undefined;
			};

			$scope.generateError = function (message) {
				$scope.errorList.push(message);
			};

			$scope.initMap = function(coords) {
				if ($window.google) {

					if(!coords) {
						var defaultCenter = {
							lat: 41.387152,
							lng: 2.170047
						};
						coords = defaultCenter;
					}

					var latlng = new google.maps.LatLng(coords.lat, coords.lng);
					var mapOptions = {
						zoom: 13,
						maxZoom: 18,
						minZoom: 10,
						center: latlng,
						backgroundColor: "none",
						navigationControl: false,
						mapTypeControl: false,
						scaleControl: false,
						draggable: true
					};
					$scope.map = new google.maps.Map(document.getElementById("map-track"), mapOptions);
					google.maps.event.addListenerOnce($scope.map, 'idle', function () {
						//$scope.updatePackageMap();
					});
				} else {
					$scope.generateError("No se ha podido cargar Google Maps");
				}
			};

			function areSameCoords(newBundle, oldBundle) {
				return  (newBundle && oldBundle) &&
					(newBundle.latitude == oldBundle.latitude && newBundle.longitude == oldBundle.longitude);
			}

			function hasNewValues(newV, oldV) {
				console.log("DEBUG hasNewValues -> NEW: ",newV," oldV: ",oldV);
				var infoKeys = ['origin', 'destination', 'driver'];
				var i = 0;
				var itChanged = (newV.status !== oldV.status) || (newV.destination.status !== oldV.destination.status);
				while(i < infoKeys.length && !itChanged){
					var iKey = infoKeys[i];
					if(newV[iKey] && oldV[iKey]) {
						itChanged = !areSameCoords(newV[iKey], oldV[iKey]);
						if(itChanged) {
							console.log("DEBUG hasNewValues, change FOUND! (key: ",iKey,") NEW: ", newV," OLD: ",oldV);
						}
					} else {
						itChanged = toolsService.isEmptyJson(oldV);
					}
					console.log("DEBUG itChanged -> ", itChanged);
					i++;
				}
				return itChanged;
			}

			$scope.sendRating = function(newScore, destinationId) {

				console.log("DEBUG sendRating -> deliveryId: ", $scope.deliveryId, " ratingBundle: ", $scope.ratingBundle);
				$scope.ratingFeedback = "";
				$scope.ratingBundle.readOnly = true;
				if( newScore && destinationId ) {
					DeliversService.sendRating(newScore, destinationId).then(function (res) {
						console.log("DEBUG sendRating return: ", res);
					}, function (e) {
						console.log("DEBUG sendRating error: ", e);
					}).finally(function () {
						$scope.ratingFeedback = 'track-package.thank-you';
						//$timeout(function () {
						// $scope.ratingFeedback = "";
						//}, Configuration.defaultTimeout);
					});
				}
			};

			$scope.getUpdate = function(trackingCode) {

				DeliversService.getInfoFromTrackingCode(trackingCode).then(function(info) {
					console.log("getUpdate RES: ", info);
					if(oldValues && info && oldValues.status != info.status || info.destination.status != oldValues.destination.status) {
						console.log("DEBUG getUpdate > hago CleanView!");
						$scope.cleanView();
					}

					if(['created', 'no_found', 'pending_driver_acceptance', 'reading_delivery'].indexOf(info.status) > -1) {
						$scope.origin = info.origin;
						$scope.destination = info.destination;
						$scope.transport = info.transport;
						$scope.yourShargoInfo = {
							name: ask4Shargo,
							imageUrl: "img/svg/loading-y.svg"
						};
						$scope.status = "";
					} else if(['scheduled', 'cargo'].indexOf(info.status) > -1) {
						$scope.origin = info.origin;
						$scope.destination = info.destination;
						$scope.transport = info.transport;
						$scope.orderDate = info.orderDate;
						$scope.yourShargoInfo = {
							name: estimatedPickup + ":",
							imageUrl: "img/svg/dest-icon-black.svg"
						};
						var oDate = new Date(info.orderDate);
						$scope.status = $filter('addZeros')(oDate.getHours()) + ":" + $filter('addZeros')(oDate.getMinutes());
					} else if(['assigned', 'in_route', 'delivered', 'delivered_with_errors', 'canceled', 'returned'].indexOf(info.status) > -1) {
						$scope.driver = info.driver;
						$scope.origin = info.origin;
						$scope.destination = info.destination;
						$scope.transport = info.transport;
						$scope.yourShargoInfo = $scope.driver || {};
						$scope.closingReason = info.closingReason;
						console.log($scope.driver);
						$scope.yourShargoInfo.imageCss = "image";
						if($scope.destination.status == 2) {
							$translate($filter('statusName')('canceled')).then(function(t) {
								$scope.status = t;
							});
						} else if($scope.destination.status == 1) {
							$translate($filter('statusName')('delivered')).then(function(t) {
								$scope.status = t;
							});
						} else {
							$translate($filter('statusName')(info.status)).then(function(t) {
								$scope.status = t;
							});
						}
					}

					$scope.statusClass = info.status;
					$scope.origin.durationStr = $filter('formatDuration')($scope.origin.duration);
					$scope.destination.durationStr = $filter('formatDuration')($scope.destination.duration);

					// rating stuff
					$scope.deliveryId = info.id;

					// IMPROVEMENT: validate number between 0 - 5
					if(info.driverRating) {
						console.log("DEBUG setting DRIVER rating as read-only");
						$scope.ratingBundle.readOnly = true;
						$scope.ratingBundle.score = info.driverRating;
					}
					// rate stuff ends here
					console.log("TO CHECK NEW VALUES", info, oldValues);
					if(hasNewValues(info, oldValues)) {
						console.log("DEBUG updating map information");
						var deprecatedValues = _.clone(oldValues);
						$scope.updatePackageMap(info, deprecatedValues);
						oldValues = info;
					} else {
						console.log("DEBUG idle (arrived same info)");
					}
				}, function(error){
					$location.path( $rootScope.url('notfound') );
				});
			};

			$scope.updatePackageMap = function (info, oldValues) {
				// UPDATE only if it's necessary
				console.log("DEBUG updatePackageMap with ", info," and oldValues: ", oldValues);
				var markerCfgsArray = [];

				var isEmptyJson = toolsService.isEmptyJson(oldValues);

				if(isEmptyJson || !areSameCoords(info.origin, oldValues.origin) || info.status !== oldValues.status) {
					console.log("DEBUG updatePackageMap > Actualizo origin");
					var origin = {
						coordinates: {
							lat: info.origin.latitude,
							lng: info.origin.longitude
						},
						key: "pickup",
						icon: {url: "./img/svg/map-delivery-black.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
						zIndex: 100,
						msg: "pickup"
					};
					markerCfgsArray.push(origin);
				}

				if(isEmptyJson || !areSameCoords(info.destination, oldValues.destination) || info.status !== oldValues.status || info.destination.status !== oldValues.destination.status) {
                    var colorIconDestination = (info.destination.status == 2) ? 'drop-off-r' : 'map-placemark-black';
					console.log("DEBUG updatePackageMap > Actualizo destination > new colorIconDestination: ",colorIconDestination);
					var destination = {
						coordinates: {
							lat: info.destination.latitude,
							lng: info.destination.longitude
						},
						key: "delivery",
						icon: {url: "./img/svg/"+colorIconDestination+".svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
						zIndex: 100,
						msg: "delivery"
					};
					markerCfgsArray.push(destination);
				}

				if((driverStatuses.indexOf(info.status) > -1 && info.destination.status != 1) && (isEmptyJson || !areSameCoords(info.driver, oldValues.driver))) {
					console.log("DEBUG updatePackageMap > Actualizo driver", info);

					var driver = {
						coordinates: {
							lat: info.driver.latitude,
							lng: info.driver.longitude
						},
						key: "driver",
						icon: {url: "./img/svg/map-driver-" + info.transport + "-yellow.svg", size: new google.maps.Size(50, 50), scaledSize: new google.maps.Size(50, 50), origin: new google.maps.Point(0, 0), anchor: new google.maps.Point(0, 50)},
						zIndex: 100,
						msg: "driver"
					};
					markerCfgsArray.push(driver);
				} else if(driverStatuses.indexOf(info.status) == -1 || info.destination.status == 1){
					console.log("DEBUG updatePackageMap > removing driver");
					if($scope.markers && $scope.markers["driver"]) {
						$scope.markers["driver"].setMap(null);
					}
				}
				if (info.status !== oldValues.status) {
					console.log("DEBUG updatePackageMap > vacío markers");
					$scope.markers = [];
				}
				var singleBounds = new google.maps.LatLngBounds();
                markerCfgsArray.map(function(markerCfg) {
                    var latLng = {
                        lat: parseFloat(markerCfg.coordinates.lat),
                        lng: parseFloat(markerCfg.coordinates.lng)
                    };
//                    $scope.map.setCenter(latLng);
                    if (!$scope.markers[markerCfg.key]) {
                        $scope.markers[markerCfg.key] = new google.maps.Marker({
                            map: $scope.map,
                            position: latLng,
                            icon: markerCfg.icon,
							optimized: false,
                            zIndex: markerCfg.zIndex
                        });
                    } else {
                        $scope.markers[markerCfg.key].setPosition(latLng);
						$scope.markers[markerCfg.key].setIcon(markerCfg.icon);
                    }
                    $scope.markers[markerCfg.key].setMap($scope.map);
                });

				console.log("DEBUG updatePackageMap markerCfg: ", markerCfgsArray);
				if($scope.markers){
					Object.keys($scope.markers).forEach(function(mrkKey) {
						var mrk = $scope.markers[mrkKey];
						var newlatlngBundle = new google.maps.LatLng(mrk.position.lat(), mrk.position.lng());
						console.log("DEBUG updatePackageMap mkrkKey: ",mrkKey," mrk.position -> ", mrk.position);
						singleBounds.extend(newlatlngBundle);
					});
					console.log("DEBUG updatePackageMap fitBounds con markers: ", $scope.markers);
                    $scope.map.fitBounds(singleBounds);
                }
			};

			var trackingCode = $routeParams.trackingCode;
			if($scope.pageKey && $scope.pageKey.name ==  "track-shortlink") {
				console.log("-----------------> SHORTID: ", trackingCode);
				// shortid
				DeliversService.getTrackingCode(trackingCode).then(function(codeBundle) {
					console.log("getTrackingCode response: ", codeBundle);
					trackingCode = codeBundle.id;
					delayMapInit();
				});
			} else {
				trackingCode = $routeParams.trackingCode;
				delayMapInit();
			}

			function delayMapInit() {
				$timeout(function() {
					$scope.initMap();
					$scope.getUpdate(trackingCode);
				}, 1000);
			}

			var stopUpdate = $interval(function() {
				console.log("INTERVAL GET UPDATE");
				$scope.getUpdate(trackingCode);
			}, Configuration.updateInterval * 1000);

			$scope.$on("$destroy", function( event ) {
					$interval.cancel( stopUpdate );
					stopUpdate = undefined;
				}
			);

			document.addEventListener('visibilitychange', function() {
				if (!angular.isUndefined(stopUpdate)) {
					$interval.cancel(stopUpdate);
					stopUpdate = undefined;
				}
				else {
					stopUpdate = $interval(function() {
						$scope.getUpdate(trackingCode);
					}, Configuration.updateInterval * 1000);
				}
			});
		});
})();
